<template>
  <b-button
    :style="{ 'background-color': toggleColor }"
    variant="black"
    v-b-tooltip.hover
    title="Download CSV"
    size="sm"
    @click="handleClick">
    <b-icon variant="light" icon="download"></b-icon>
  </b-button>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import exportToCsv from '@/xvisor/utilities/csvExporter';
import formatters from '@/xvisor/utilities/csvFormatters';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
    dataType: {
      type: String,
      default: 'default',
    },
    usesPagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      csvFormatters: {
        packages: formatters.formatPackages,
        traffic: formatters.formatTraffic,
      },
    };
  },
  computed: {
    hasData() {
      return this.data && this.data.length > 0;
    },
    toggleColor() {
      return `${themeStyle.styleToggle(colorPalette.orange, colorPalette.blue)} !important`;
    },
  },
  methods: {
    exportCsv() {
      if (!this.hasData) {
        this.$bvToast.toast('No data to download', {
          title: 'Notice',
          variant: 'warning',
        });
        return;
      }
      let formatter;
      if (this.dataType && this.dataType in this.csvFormatters) {
        formatter = this.csvFormatters[this.dataType];
      } else {
        formatter = (d) => d;
      }
      try {
        exportToCsv(this.data, formatter);
        this.$bvToast.toast('Successfully created CSV', {
          title: 'Notice',
          variant: 'success',
        });
      } catch (error) {
        this.$bvToast.toast('Failed to create CSV', {
          title: 'Notice',
          variant: 'danger',
        });
      }
    },
    handleClick() {
      if (this.usesPagination) {
        this.$emit('exportData');
      } else {
        this.exportCsv();
      }
    },
  },
  watch: {
    data() {
      if (this.usesPagination) this.exportCsv();
    },
  },
};
</script>
